/* Batik Boutique PostHog pilot. No customer identity or form values collected. */
(function () {
  'use strict';
  if (window.__bbPostHogInstalled) return;
  window.__bbPostHogInstalled = true;
  var config = window.BB_POSTHOG_CONFIG;
  if (!config || !config.enabled) return;
  if (/\/(?:account|checkouts?|orders|password)(?:\/|$)/i.test(location.pathname)) return;
  var host = 'https://us.i.posthog.com';
  var token = 'phc_q7xShkN5Ew5zBcFKZMjs6p49xBz9tHwSBaQRzF7MqhPx';
  var bridgeKey = 'bb_ph_bridge_v1';
  var started = false, active = false, pageSent = false, sdk = null;
  var pendingEnquiry = null, acquisition = null;
  var attributionKey = 'bb_ph_acquisition_v2';
  var query = new URLSearchParams(location.search);
  function read(store, key) { try { return store.getItem(key); } catch (_) { return null; } }
  function put(store, key, value) { try { store.setItem(key, value); } catch (_) {} }
  function drop(store, key) { try { store.removeItem(key); } catch (_) {} }
  if (query.get('bb_ph_staff') === '1') put(localStorage, 'bb_ph_exclude', '1');
  if (query.get('bb_ph_qa') === '1') put(sessionStorage, 'bb_ph_qa', '1');
  var qa = read(sessionStorage, 'bb_ph_qa') === '1';
  var excluded = read(localStorage, 'bb_ph_exclude') === '1' || !!window.Shopify?.designMode || query.has('preview_theme_id');
  if (excluded || (config.mode === 'qa' && !qa)) return;
  if (/bot|crawler|spider|headless|lighthouse|pagespeed|facebookexternalhit/i.test(navigator.userAgent)) return;
  function cleanUrl(value) {
    try {
      var u = new URL(value, location.origin);
      if (!/^https?:$/.test(u.protocol)) return '';
      var p = u.pathname;
      if (/@|%40|\/account|\/checkouts?\/|\/orders\/|\/thank_you|\/password/i.test(p)) p = '/redacted';
      return u.origin + p;
    } catch (_) { return ''; }
  }
  function acquisitionForVisit() {
    if (acquisition) return acquisition;
    var saved;
    try { saved = JSON.parse(read(sessionStorage, attributionKey)); } catch (_) {}
    if (saved && Date.now() - saved.updated_at < 1800000 && saved.version === 2) {
      acquisition = saved;
    } else {
      var s = (query.get('utm_source') || '').toLowerCase();
      var ref = '';
      try { ref = new URL(document.referrer).hostname.toLowerCase(); } catch (_) {}
      var internal = ref === 'batikboutique.com' || ref.endsWith('.batikboutique.com');
      var combined = s + ' ' + (internal ? '' : ref);
      var source = 'direct_or_unknown';
      if (/google/.test(combined) || query.has('gclid')) source = 'google';
      else if (/facebook|instagram|meta/.test(combined) || query.has('fbclid')) source = 'meta';
      else if (/omnisend/.test(combined)) source = 'omnisend';
      else if (/tiktok/.test(combined)) source = 'tiktok';
      else if (ref && !internal) source = 'other_referral';
      var medium = (query.get('utm_medium') || '').toLowerCase();
      if (!/^(cpc|ppc|paid|paid_social|social|email|sms|organic|referral|display|affiliate)$/.test(medium)) medium = '';
      if (!medium && query.has('gclid')) medium = 'cpc';
      if (!medium && source === 'omnisend') medium = 'email';
      acquisition = {version:2, source:source, medium:medium,
        tagged:!!s || query.has('gclid'),
        // Only the referring hostname; never its path, query or customer information.
        referrer:!internal && /^[a-z0-9.-]+$/.test(ref) ? ref : '',
        landing:cleanUrl(location.href)};
    }
    acquisition.updated_at = Date.now();
    if (permitted()) put(sessionStorage, attributionKey, JSON.stringify(acquisition));
    return acquisition;
  }
  function source() { return acquisitionForVisit().source; }
  function permitted() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function properties() {
    var current = cleanUrl(location.href);
    var a = acquisitionForVisit();
    return { $current_url: current, $pathname: new URL(current).pathname,
      $raw_user_agent: navigator.userAgent,
      $referrer: a.referrer ? 'https://' + a.referrer + '/' : '$direct',
      $referring_domain: a.referrer || '$direct',
      utm_source: a.tagged && /^(google|meta|omnisend|tiktok)$/.test(a.source) ? a.source : undefined,
      utm_medium: a.medium || undefined,
      bb_is_test: qa, bb_source: a.source, bb_page_type: config.pageType,
      bb_landing_page: a.landing,
      bb_schema_version: 2 };
  }
  function capture(name, extra) {
    if (!active || !permitted() || !sdk?.capture) return;
    sdk.capture(name, Object.assign(properties(), extra || {}));
    if (sdk.get_distinct_id) bridge();
  }
  function bridge() {
    if (!active || !permitted() || !sdk) return;
    put(localStorage, bridgeKey, JSON.stringify({distinct_id: sdk.get_distinct_id(),
      session_id: sdk.get_session_id(), is_test: qa, source: source(),
      landing_page: acquisitionForVisit().landing, attribution: acquisitionForVisit(), updated_at: Date.now()}));
  }
  var allowedEvents = new Set(['$pageview', '$snapshot', 'bb_product_viewed', 'bb_corporate_page_viewed',
    'bb_enquiry_succeeded', 'bb_enquiry_form_viewed', 'bb_enquiry_form_interacted', 'bb_whatsapp_clicked', 'bb_email_clicked', 'bb_size_selected', 'bb_size_guide_opened']);
  var allowedProps = new Set(['distinct_id','$device_id','$session_id','$window_id','$lib','$lib_version',
    '$raw_user_agent','$referrer','$referring_domain','utm_source','utm_medium',
    '$browser','$browser_version','$os','$os_version','$device_type','$screen_width','$screen_height',
    '$viewport_width','$viewport_height','$host','$current_url','$pathname','$insert_id','$time',
    '$process_person_profile','$is_identified','$snapshot_data','$snapshot_bytes','$session_recording',
    'bb_is_test','bb_source','bb_page_type','bb_landing_page','bb_schema_version','product_id','variant_id','size','form_id']);
  function beforeSend(event) {
    if (!active || !permitted() || !allowedEvents.has(event.event)) return null;
    var p = event.properties || {};
    Object.keys(p).forEach(function(k) { if (!allowedProps.has(k)) delete p[k]; });
    if (p.$current_url) p.$current_url = cleanUrl(p.$current_url);
    if (p.bb_landing_page) p.bb_landing_page = cleanUrl(p.bb_landing_page);
    p.token = token; // Public project token required by PostHog ingestion.
    p.bb_is_test = qa;
    p.$process_person_profile = false;
    return event;
  }
  function loadSdk() {
    if (started || !permitted()) return;
    if (window.posthog?.__loaded) return; // Do not duplicate or alter another installation.
    started = true; active = true;
    if (!read(sessionStorage, 'bb_ph_landing')) put(sessionStorage, 'bb_ph_landing', cleanUrl(location.href));
    var e = window.posthog = window.posthog || [];
    if (e.__SV) return;
    e._i = []; e.__SV = 1;
    ['capture','register','opt_out_capturing','opt_in_capturing','set_config','stopSessionRecording'].forEach(function(n) {
      e[n] = function() { e.push([n].concat(Array.prototype.slice.call(arguments))); };
    });
    var safeText = /^(?:add to (?:cart|bag)|checkout|check out|buy it now|sold out|unavailable|size|size guide|size chart|quantity|name|email|phone|company|message|submit|send|contact us|request (?:a )?quote|delivery|shipping|continue shopping|cart|your cart|close|remove|xs|s|m|l|xl|[2-6]xl|\+|−|-)$/i;
    var options = {
      api_host: host, ui_host: 'https://us.posthog.com', defaults: '2026-08-30',
      autocapture:false, capture_pageview:false, capture_pageleave:false, capture_dead_clicks:false,
      rageclick:false, capture_heatmaps:false, capture_exceptions:false, capture_performance:false,
      capture_webmcp:false, enable_recording_console_log:false, disable_surveys:true,
      disable_product_tours:true, disable_conversations:true, disable_web_experiments:true,
      advanced_disable_feature_flags:true, remote_config_refresh_interval_ms:0,
      person_profiles:'never', save_referrer:false, save_campaign_params:false,
      disable_capture_url_hashes:true, opt_out_useragent_filter:false, respect_dnt:true,
      disableDeviceModel:true, persistence:'localStorage', before_send:beforeSend,
      disable_session_recording: !config.replayEnabled || (config.replayMode === 'qa' && !qa),
      session_recording:{maskAllInputs:true, maskTextSelector:'*', maskAllElementAttributes:true,
        maskTextFn:function(text) {return safeText.test(text.trim()) ? text : '*'.repeat(text.length);},
        blockSelector:'iframe, [contenteditable], .ph-no-capture',
        recordCrossOriginIframes:false, captureJsonLd:false, recordBody:false, recordHeaders:false,
        maskCapturedNetworkRequestFn:function(request) {if(request.name)request.name=cleanUrl(request.name);return request;}
      },
      loaded:function(instance) {
        sdk = instance;
        if (!permitted()) { active=false; instance.opt_out_capturing(); return; }
        if (!pageSent) {
          pageSent=true;capture('$pageview');
          if(config.productId)capture('bb_product_viewed',{product_id:String(config.productId),variant_id:String(config.variantId || '')});
          if(config.isCorporate)capture('bb_corporate_page_viewed');
          document.querySelectorAll('[data-bb-enquiry-success]').forEach(function(el) {
            if(!config.isCorporate)return;
            var id=el.getAttribute('data-bb-enquiry-success');
            var key='bb_ph_enquiry_'+id;
            var pending=Number(read(sessionStorage,key));
            if(pending && Date.now()-pending < 1800000){drop(sessionStorage,key);capture('bb_enquiry_succeeded',{form_id:id});}
          });
        }
        if (pendingEnquiry) { capture('bb_enquiry_succeeded', {form_id:pendingEnquiry}); pendingEnquiry=null; }
        bridge();
      }
    };
    e._i.push([token,options,'posthog']);
    var script=document.createElement('script');script.async=true;script.crossOrigin='anonymous';
    script.src=host+'/static/array.js';script.referrerPolicy='no-referrer';
    document.head.appendChild(script);
  }
  function syncConsent() {
    if(permitted()) {
      if(!started)loadSdk();
      else if(!active){active=true;sdk?.opt_in_capturing({captureEventName:false});bridge();}
    } else {
      active=false;pendingEnquiry=null;acquisition=null;drop(localStorage,bridgeKey);drop(sessionStorage,'bb_ph_landing');drop(sessionStorage,attributionKey);
      if(started){sdk?.stopSessionRecording();sdk?.opt_out_capturing();}
    }
  }
  document.addEventListener('visitorConsentCollected',syncConsent);
  if(window.Shopify?.customerPrivacy)syncConsent();
  else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)syncConsent();});
  document.addEventListener('submit',function(event) {
    if(active && permitted() && config.isCorporate && event.target.matches('form[action*="/contact"]'))
      put(sessionStorage,'bb_ph_enquiry_'+event.target.id,String(Date.now()));
  },true);
  // Only this verified corporate form; never read Omnisend formValues.
  var corporateOmnisendSent = false;
  window.addEventListener('omnisendForms',function(event) {
    var detail = event.detail;
    if (!permitted() || !config.isCorporate || detail?.form?.id !== '657bc8fd9f850481ed210909') return;
    var kind = detail.eventName || detail.type;
    if (kind === 'view') capture('bb_enquiry_form_viewed',{form_id:detail.form.id});
    if (kind === 'interaction') capture('bb_enquiry_form_interacted',{form_id:detail.form.id});
    // Omnisend's completion callback, never a submit-button click or intermediate step.
    if (kind !== 'submit' || corporateOmnisendSent) return;
    corporateOmnisendSent = true;
    if (sdk && active) capture('bb_enquiry_succeeded',{form_id:detail.form.id});
    else pendingEnquiry = detail.form.id;
  });
  document.addEventListener('click',function(event) {
    var guide=event.target.closest('button[aria-controls^="size-chart--"]');
    if(guide && !guide.classList.contains('drawer__close-button'))capture('bb_size_guide_opened');
    var a=event.target.closest('a');if(!a)return;
    var href=a.getAttribute('href') || '';
    if(/^mailto:/i.test(href))capture('bb_email_clicked');
    else if(/^https:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(href))capture('bb_whatsapp_clicked');
    else if(/\/pages\/[^?#]*size-chart/.test(href))capture('bb_size_guide_opened');
  });
  document.addEventListener('change',function(event) {
    var el=event.target;
    if(!el.closest('variant-selects'))return;
    var val=String(el.value || '').trim();
    if(/^(?:XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL)$/i.test(val))capture('bb_size_selected',{size:val.toUpperCase()});
  });
})();